var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg52(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.53 67.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#00a193;}.cls-2{opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.57,34.76a4.63,4.63,0,1,0-4.63,4.63,4.64,4.64,0,0,0,4.63-4.63Zm-7,0a2.32,2.32,0,1,1,2.32,2.31,2.31,2.31,0,0,1-2.32-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.57,4.63a6.95,6.95,0,1,0,7,7,6.95,6.95,0,0,0-7-6.95Zm0,11.59a4.64,4.64,0,1,1,4.64-4.64,4.64,4.64,0,0,1-4.64,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.45,17.91a5.8,5.8,0,1,0,1.25,6.32A5.81,5.81,0,0,0,50.45,17.91Zm-1.64,6.56a3.48,3.48,0,1,1,.75-3.79A3.48,3.48,0,0,1,48.81,24.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.81,24.47a3.48,3.48,0,1,1,.75-3.79A3.48,3.48,0,0,1,48.81,24.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.13,30.12H16.23a1.16,1.16,0,0,0-1.16,1.16v6.95a1.16,1.16,0,0,0,1.16,1.16h13.9a1.16,1.16,0,0,0,1.16-1.16V31.28A1.16,1.16,0,0,0,30.13,30.12Zm-1.16,7H17.38V32.44H29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.37,60.25H59.85A10.42,10.42,0,0,0,53.3,41.71a15.67,15.67,0,0,0-3.48.52,20.21,20.21,0,0,1-4.63.64,20.12,20.12,0,0,1-4.62-.64,15.76,15.76,0,0,0-3.49-.52V24.33a5.8,5.8,0,0,0-5.79-5.8H30.13V15.06A1.16,1.16,0,0,0,29,13.9H26.65V7h4.64v3.47a1.16,1.16,0,0,0,1.16,1.16h4.63a1.16,1.16,0,0,0,1.16-1.16V5.79A5.79,5.79,0,0,0,32.45,0H18.54a3.47,3.47,0,0,0-3.47,3.47V5.79A1.16,1.16,0,0,0,16.23,7H19.7v7H17.38a1.15,1.15,0,0,0-1.15,1.16v3.47H15.07a5.82,5.82,0,0,0-5.8,5.8V56.77a5.74,5.74,0,0,0,1.17,3.48H1.16A1.16,1.16,0,0,0,0,61.41,5.81,5.81,0,0,0,5.8,67.2H63.73a5.81,5.81,0,0,0,5.8-5.79A1.16,1.16,0,0,0,68.37,60.25ZM37.08,44a14,14,0,0,1,3,.46,22,22,0,0,0,5.13.69,22,22,0,0,0,5.14-.69,13.81,13.81,0,0,1,3-.46,8.11,8.11,0,0,1,0,16.22H37.08a8.11,8.11,0,0,1,0-16.22ZM17.38,4.63V3.47a1.16,1.16,0,0,1,1.16-1.16H32.45a3.47,3.47,0,0,1,3.47,3.48V9.26H33.61V5.79a1.16,1.16,0,0,0-1.16-1.16Zm7,2.32v7H22V7Zm-5.8,9.27h9.27v2.31H18.54Zm-6.95,8.11a3.48,3.48,0,0,1,3.48-3.48H31.29a3.47,3.47,0,0,1,3.47,3.48v1.16H11.59Zm0,3.47H34.76V42a10.45,10.45,0,0,0-8.11,10.17,11.09,11.09,0,0,0,.07,1.15H11.59Zm0,27.81H27.25a10.56,10.56,0,0,0,3.29,4.64H15.07a3.49,3.49,0,0,1-3.48-3.48Zm52.14,9.27H5.8a3.47,3.47,0,0,1-3.28-2.32H67A3.48,3.48,0,0,1,63.73,64.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.92,5.79V9.26H33.61V5.79a1.16,1.16,0,0,0-1.16-1.16H17.38V3.47a1.16,1.16,0,0,1,1.16-1.16H32.45A3.47,3.47,0,0,1,35.92,5.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.38,
    y: 32.44,
    width: 11.59,
    height: 4.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.76,24.33v1.16H11.59V24.33a3.48,3.48,0,0,1,3.48-3.48H31.29A3.47,3.47,0,0,1,34.76,24.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.54,60.25H15.07a3.49,3.49,0,0,1-3.48-3.48V55.61H27.25A10.56,10.56,0,0,0,30.54,60.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.92,47.5a1.16,1.16,0,0,0,1.16,1.16,14.65,14.65,0,0,1,3,.46,21.91,21.91,0,0,0,5.13.7,22,22,0,0,0,5.14-.7,14.46,14.46,0,0,1,3-.46,1.16,1.16,0,1,0,0-2.32,16.28,16.28,0,0,0-3.48.52,19.67,19.67,0,0,1-4.63.64,19.58,19.58,0,0,1-4.62-.64,16.37,16.37,0,0,0-3.49-.52,1.16,1.16,0,0,0-1.16,1.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg52);
export default __webpack_public_path__ + "static/media/52.c9db8377c6b344536452c57753993a67.svg";
export { ForwardRef as ReactComponent };